export default "__VITE_ASSET__lYYocRAd__"